// base in 2.4.1
import Dropdown from './Dropdown';
export default Dropdown;